<template>
  <v-app>
    <parent-core-app-bar v-model="expandOnHover" />

    <parent-core-drawer :expand-on-hover.sync="expandOnHover" />

    <parent-core-view />

     <!--dashboard-core-settings v-model="expandOnHover" /-->
  </v-app>
</template>

<script>
  export default {
    name: 'ParentIndex',

    components: {
      ParentCoreAppBar: () => import('./components/core/AppBar'),
      ParentCoreDrawer: () => import('./components/core/Drawer'),
      // DashboardCoreSettings: () => import('./components/core/Settings'),
      ParentCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
